module.exports = __webpack_public_path__ + "static/img/设备高温预警.e5968038.png";